class FilterSearch extends HTMLElement {
    constructor() {
        super();
        this.parent = this.parentElement;
        this.input = this.querySelector('input');
        this.searchElementsText = this.parent.querySelectorAll('.text-search')
        this.input.addEventListener('input', this.onChangeHandler.bind(this));
    }
    onChangeHandler(e) {
        e.stopPropagation(); 
        
        const val = e.target.value.toLowerCase().trim();

        this.searchElementsText.forEach(el => {
            const str = el.textContent.toLowerCase().trim();
            val && !str.startsWith(val) ? el.parentElement.classList.add('hide') : el.parentElement.classList.remove('hide')
            
        });
    }
}
customElements.define('search-fieldset', FilterSearch);